import store from '../store';
import {toggleFeature, setShowRaids, setShowGyms, setGymTeam, setFilters} from "../store/filterSlice";
import {push} from 'connected-react-router';

export const setupKeybindings = () => {
	document.addEventListener('keydown', event => {
		if( event.target.type === 'text' )
			return; // It's in an input box

		if (event.ctrlKey)
			return;

		const state = store.getState();

		if (event.key.toLowerCase() === "r") {
			if (event.shiftKey) {
				store.dispatch(setFilters({showGyms: false, showStops: false, showPokemon: false, showRaids: true}));
			} else store.dispatch(toggleFeature('showRaids'));
		} else if (event.key.toLowerCase() === "g") {
			if (event.shiftKey) {
				store.dispatch(setFilters({showGyms: true, showStops: false, showPokemon: false, showRaids: false}));
			} else store.dispatch(toggleFeature('showGyms'));
		} else if (event.key.toLowerCase() === "s") {
			if (event.shiftKey) {
				store.dispatch(setFilters({showGyms: false, showStops: true, showPokemon: false, showRaids: false}));
			} else store.dispatch(toggleFeature('showStops'));
		} else if (event.key.toLowerCase() === "p") {
			if (event.shiftKey) {
				store.dispatch(setFilters({showGyms: false, showStops: false, showPokemon: true, showRaids: false}));
			} else store.dispatch(toggleFeature('showPokemon'));
		} else if (event.key === "1" || event.key === "2" || event.key === "3" || event.key === "4" || event.key === "5" || event.key === "6") {
			store.dispatch(setShowRaids(true));
			store.dispatch(toggleFeature('raidLevel' + event.key));
		} else if (event.key === "m") {
			store.dispatch(setShowGyms(true));
			store.dispatch(setGymTeam(state.filter.gymTeam === 1 ? 0 : 1));
		} else if (event.key === "v") {
			store.dispatch(setShowGyms(true));
			store.dispatch(setGymTeam(state.filter.gymTeam === 2 ? 0 : 2));
		} else if (event.key === "i") {
			store.dispatch(setShowGyms(true));
			store.dispatch(setGymTeam(state.filter.gymTeam === 3 ? 0 : 3));
		} else if (event.key === "f") {
			store.dispatch(setShowGyms(true));
			store.dispatch(toggleFeature('gymOpenSpotsOnly'));
		} else if (event.key === "x") {
			store.dispatch(push('/s2'));
		}
	});
};